import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';

const NoticeWrite = () => {
  const navigate = useNavigate();
  const { board_seq } = useParams();

  const uploadInput = useRef();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [isMain, setIsMain] = useState(false);

  useEffect(() => {
    if (board_seq) {
      // Fetch existing board data
      const fetchBoardData = async () => {
        const formData = new FormData();
        formData.append("board_seq", board_seq);

        try {
          const successHandler = (response) => {
            const data = response.data;
            setTitle(data.board_title);
            setContent(data.board_content);
            setIsMain(data.board_is_main === 'true' ? true : false);
          };

          const errorHandler = (error) => {
            toast.error("공지사항 불러오기 중 오류가 발생했습니다.");
          };
          
          await request.get(`/board/list/admin/BD_NOTICE/${board_seq}`, formData, successHandler, errorHandler);
        } catch (error) {
          toast.error("공지사항 불러오기 중 오류가 발생했습니다.");
        }
      };

      fetchBoardData();
    }
  }, [board_seq]);

  const handleTitleChange = (e) => setTitle(e.target.value);
  const handleContentChange = (e) => setContent(e.target.value);
  const handleIsMainChange = () => setIsMain(!isMain);

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("board_title", title);
    formData.append("board_content", content);
    formData.append("board_is_main", isMain);

    // console.log(formData)
    // if (uploadInput.current.files[0]) {
    //   formData.append("image", uploadInput.current.files[0]);
    // }
    
    try {
      const successHandler = (response) => {
        if (response.messageCode === 200) {
          toast.success("공지사항이 성공적으로 등록되었습니다.");
          navigate("/Manage/Notice");
        } else {
          toast.error("공지사항 등록 중 오류가 발생했습니다.");
        }
      };

      const errorHandler = (error) => {
        toast.error("공지사항 등록 중 오류가 발생했습니다.");
      };

      if (board_seq) {
        console.log('수정')
        await request.put(`/board/BD_NOTICE/${board_seq}`, formData, successHandler, errorHandler);
      } else {
        console.log('등록')
        await request.put("/board/BD_NOTICE", formData, successHandler, errorHandler);
      }

    } catch (error) {
      toast.error("공지사항 등록 중 오류가 발생했습니다.");
    }
  };


  return (
    <main>
      <h2 className="adm_com_pg_tit">공지사항 {board_seq ? "수정" : "등록"}</h2>
      <div className="adm_com_pg_content">
        <table className='adm_com_board_list type_row'>
          <colgroup>
            <col width="10%" /><col />
          </colgroup>
          <tbody>
            <tr>
              <th>작성자</th>
              <td>관리자</td>
            </tr>
            <tr>
              <th>메인공지여부</th>
              <td>
                <section className="check">
                  <input
                    type="checkbox"
                    id="chk01"
                    className="adm_com_chk"
                    checked={isMain}
                    onChange={handleIsMainChange}
                  />
                  <label htmlFor="chk01">메인공지</label>
                </section>
              </td>
            </tr>
            <tr>
              <th>제목</th>
              <td>
                <input
                  type="text"
                  className="input"
                  value={title}
                  onChange={handleTitleChange}
                />
              </td>
            </tr>
            <tr>
              <th>이미지</th>
              <td>
                <div className="btn_attach">
                  <input type="file" className="input_file" ref={uploadInput} />
                </div>
              </td>
            </tr>
            <tr>
              <th>내용</th>
              <td>
                <textarea
                  className="textarea"
                  value={content}
                  onChange={handleContentChange}
                  rows="10"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="adm_com_btn_wrap center">
          <button className="adm_com_btn blue" onClick={handleSubmit}>{board_seq ? "수정" : "등록"}</button>
          <button className="adm_com_btn gray" onClick={() => navigate("/Manage/Notice")}>취소</button>
        </div>
      </div>
      <ToastContainer />
    </main>
  );
};

export default NoticeWrite;
